<template>
    <div v-if="error" class="flex h-screen justify-center items-center">
        <div class="m-auto">
            <p>{{error}}</p>
        </div>
    </div>

    <div v-else-if="loading" class="h-screen w-full">
        <div class="flex h-screen items-center">
            <vue-loaders
                name="ball-spin-fade-loader"
                color="#2a4365"
                class="flex m-auto my-4"
                scale="1"
            ></vue-loaders>
        </div>
    </div>

    <div v-else class="mx-auto">
<!--    <div class=' flex flex-shrink-0 flex-col md:flex md:flex-wrap flex-col-unset justify-center items-center py-5 h-screen'>-->

<!--        <div class='px-6 invisible md:visible'>-->
<!--            <button class="btn"  @click="previous">prev</button>-->
<!--&lt;!&ndash;            <button class='carousel-controls__button' @click="next">next</button>&ndash;&gt;-->
<!--        </div>-->

<!--        <transition-group-->
<!--            class='flex justify-center items-center overflow-hidden h-screen' tag="div">-->
<!--            <div-->
<!--                v-for="slide in slides"-->
<!--                class='flex m-4 justify-center items-center slide w-1/3'-->
<!--                :key="slide.id">-->
<!--&lt;!&ndash;                <h4> {{ slide.title }} </h4>&ndash;&gt;-->
<!--                <div class="rounded-lg m-1">-->
<!--                    <images class="w-full rounded-lg" :alt="slide.title"-->
<!--                         :src="slide.title"/>-->
<!--                </div>-->

<!--&lt;!&ndash;                    <h4> {{ slide.title }} </h4>&ndash;&gt;-->
<!--&lt;!&ndash;                </images>&ndash;&gt;-->
<!--&lt;!&ndash;                <images src="https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg" alt="index" class="object-cover">&ndash;&gt;-->
<!--            </div>-->
<!--        </transition-group>-->

<!--        <div class='flex md:block px-6  w-2/3 md:w-auto justify-between md:justify-center'>-->
<!--            <button class='visible md:hidden btn' @click="previous">prev</button>-->
<!--            <button class="btn"  @click="next">next</button>-->
<!--        </div>-->
<!--    </div>-->
        <div class="flex-col">
            <div class="flex flex-wrap items-center mb-2 py-4 px-4 bg-gray-200 text-gray-700
            hover:text-black shadow-lg cursor-pointer" @click="goBack">
                <ArrowLeftIcon class="mr-1 h-6 w-8 object-cover" ></ArrowLeftIcon>
                <p class="text-lg capitalize">Back</p>
            </div>
            <div class="flex py-3 px-3 text-gray-100 font-semibold text-xl tracking-wide uppercase underline text-center
             justify-center bg-blue-800 shadow-md">
                <p>{{album.title}}</p>
            </div>
        </div>

        <!-- <div v-if="album.photos != null" class="mx-auto sm:w-11/12 w-70 md:justify-center h-90">
            <vueper-slides  arrows-outside :fade="true" :touchable="false" 
            :fraction="true" :autoplay="true" :duration="3000" :progress=true :slide-ratio="0.8"
                           bullets-outside fixed-height="80vh">
                <vueper-slide class="object-contain"
                    v-for="(photo, i) in album.photos"
                    :key="i"
                    :image="photo.photo_link" />
            </vueper-slides>
        </div>
        <div v-if="album.photos != null" class="mx-auto sm:w-11/12 w-70 md:justify-center h-90">
        </div> -->

<div v-if="album.photos != null" class="mx-auto sm:w-11/12 w-80 md:justify-center h-90">
        <viewer v-if="album.photos.length > 0" :photos="album.photos"></viewer>
                    <img v-else alt="Placeholder" class="block h-56 w-full object-cover" src="../../images/loading.gif">
</div>

    </div>
</template>

<style>
.ex--center-mode {
  width: 600px;
  max-width: 100%;
  margin: auto;
}

.vueperslide__image {
    /* Make the image rounded. */
    border-radius: 100px;

    /* Make the image scale from the slideshow height. width 0 & padding trick to keep image ratio */
    height: 60%;
    width: 0;
    padding-left: 20%;

    /* positioning at the center. */
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
}

.vueperslide__image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
}

.vueperslide__content-wrapper {
    top: 85%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
}

/* Lastly your title styles. */
.vueperslide__title {
    font-size: 3em;
    opacity: .7;
    text-shadow: none;
    color: #376098;
}

</style>

<script>
    // import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css';
    import {ArrowLeftIcon} from 'vue-feather-icons';
    import viewer from "./Viewer";
    import Axios from 'axios';
// import Viewer from './viewer.vue';

    export default {
        name: "AlbumView",
        components: { 
            // VueperSlides, VueperSlide, 
        ArrowLeftIcon, viewer 
        },
        data: function(){
            return {
                album: {},
                error: {},
                loading: false,
                // link: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                // slides: [
                //     {
                //         title: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                //         id: 1
                //     },
                //     {
                //         title: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-2.jpg',
                //         id: 2
                //     },
                //     {
                //         title: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                //         id: 3
                //     },
                //     {
                //         title: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-2.jpg',
                //         id: 4
                //     },
                //     {
                //         title: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                //         id: 5
                //     }
                // ],
            }
        },

        methods: {
            goBack(){
                // this.$router.push('/home');
                this.$router.back();
            },

            getAlbum(){
                let id = this.$route.params.id;
                let token = localStorage.getItem('token');
                this.loading = true;

                // console.log(id);
                // console.log(token);

                this.error = null;
                if(token === null){
                    this.router.push('/');
                    this.$swal('Please login');
                }else {
                    
                    Axios.get(`/api/gallery/${id}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }).then(response => {
                        // console.log(response.data);
                        this.loading = false;
                        if (response.data.status === true) {
                            this.album = response.data.data;
                        } else {
                            // this.error = '404: Not found';
                            this.router.push('/');
                            this.$swal('Please login');
                        }
                    }).catch(e => {
                        // this.error = e.toString();
                        // console.log(e);
                        e.toString();
                        this.loading = false;
                        this.loading = false;
                        // this.error = 'Page not found';
                    })
                }
            },

            next () {
                const first = this.slides.shift();
                this.slides = this.slides.concat(first)
            },
            previous () {
                const last = this.slides.pop();
                this.slides = [last].concat(this.slides)
            }

        },
        created() {
            this.getAlbum();
        }

    }
</script>

<style scoped>
    .carousel-view {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .carousel {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        width: 24em;
        min-height: 25em;
    }

    .vueperslides--fixed-height { height: 70vh; }

    .vueperslides__progress {
        background: rgba(0, 0, 0, 0.25);
        color: #71dec0;
    }

    @media (min-width: 768px){
        .flex-col-unset {
            flex-direction: unset;
        }
    }

    .btn{

        /*px-4 py-1 bg-white border-blue-900 hover:bg-blue-900 rounded-lg text-blue-900 hover:text-white*/
        padding: 0.25rem 1rem;
        background-color: white;
        border-color: #2a4365;
        border-radius: 0.5rem;
        color: #2a4365;
        border-width: 1px;



    }
    .btn:hover{
        background-color: #2a4365;
        color: white;
    }
    .slide {
        flex: 0 0 20em;
        height: 70vh;
        width: 5vh;
        /*margin: 1em;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
        /*border: 0.1em dashed #000;*/
        /*border-radius: 5%;*/
        transition: transform 0.3s ease-in-out;
    }
    /*.slide:first-of-type {*/
    /*    opacity: 0;*/
    /*    width: 4.5vh;*/
    /*    height: 50vh;*/
    /*}*/
    /*.slide:last-of-type {*/
    /*    opacity: 0;*/
    /*}*/

    /*.vueperslide__image {*/
    /*    object-fit: fill;*/
    /*}*/

    @media (min-width: 768px){
        .w-70 {
            width: 55%;
        }
    }

    .contain{
        object-fit: contain !important;
    }




</style>
